import Parse from 'parse'
import miniToastr from 'mini-toastr'
import Vue from 'vue'
import mathjs from 'mathjs'
import ClientOAuth2 from 'client-oauth2'
import * as JsPDF from 'jspdf'

// console.log('teste', process.env.APP_ID)
Parse.initialize(process.env.APP_ID)
Parse.serverURL = process.env.SERVER_URL
var properties = {}
properties.passwordChangeURL = process.env.SERVER_URL + '/apps/' + process.env.APP_ID + '/request_password_reset'

miniToastr.init()

const GlobalChannel = new Vue({})

var ifpeAuth = new ClientOAuth2({
  clientId: process.env.APP_ID,
  clientSecret: '',
  accessTokenUri: 'https://acesso.ifpe.edu.br/realms/master/protocol/openid-connect/token',
  authorizationUri: 'https://acesso.ifpe.edu.br/realms/master/protocol/openid-connect/auth',
  redirectUri: process.env.PUBLIC_URL + '/#/auth/callback',
  state: 'asdhaisdhasd',
  scopes: ['openid', 'profile', 'email', 'offline_access']
})

const computeValue = (formula, fieldsInstances) => {
  let concreteFormula = formula
  fieldsInstances.forEach(f => {
    var re = new RegExp(f.name, 'g')
    concreteFormula = concreteFormula.replace(re, f.value || f.stringField || f.numField || f.dateField || '0')
  })
  return String(mathjs.eval(concreteFormula))
}

const createDocumentFile = (formField, event) => {
  let counter = 0
  let allowedFileExtensions = ['bmp', 'gif', 'jpeg', 'jpg', 'png']
  if (event && event.target.files.length > 0) {
    var doc = new JsPDF('p', 'mm', [400, 480])
    for (var i = 0; i < event.target.files.length; i++) {
      let readFunction = (file, i) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (saveFile) {
          let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length).toLowerCase()
          if (allowedFileExtensions.includes(fileExtension)) {
            doc.addImage(reader.result, fileExtension, 20, 20, 360, 440)
          } else {
            this.message = 'A extensão ' + fileExtension + ' não é válida para os anexos.'
            miniToastr.error(this.message)
            throw this.message
          }
          counter++
          if (counter !== event.target.files.length) {
            doc.addPage()
          } else {
            var output64 = btoa(doc.output())
            let parseFile = new Parse.File('file' + Math.random().toString(36).substring(7) + '.pdf', { base64: output64 })
            formField.value = parseFile
            formField.filename = 'generatedDocument.pdf'
          }
        }
        reader.onerror = function (error) {
          console.log('Error: ', error)
        }
      }
      readFunction(event.target.files[i], i)
    }
  }
}

const createParseFile = (formField, event) => {
  if (event && event.target.files.length > 0) {
    let file = event.target.files[0]
    let allowedFileExtensions = ['.bmp', '.doc', '.gif', '.jpeg', '.jpg', '.pdf', '.png', '.dwg', '.zip', '.rar', '.doc']
    let fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length).toLowerCase()
    if (allowedFileExtensions.includes(fileExtension)) {
      let parseFile = new Parse.File('file' + Math.random().toString(36).substring(7) + fileExtension, file)
      formField.value = parseFile
      formField.filename = file.name
    } else {
      this.message = 'A extensão ' + fileExtension + ' não é válida para os anexos.'
      miniToastr.error(this.message)
      throw this.message
    }
  }
}

export {
  Parse,
  miniToastr,
  GlobalChannel,
  ifpeAuth,
  computeValue,
  properties,
  createParseFile,
  createDocumentFile
}

GlobalChannel.$on('loginSuccess', function (self) {
  let next = self.$route.query.next
  self.$router.push(next || '/openRequest')
})



// WEBPACK FOOTER //
// ./src/Global.js